import React from "react";
import { useTheme } from "@emotion/react";

//  * Import styles
import { accountSetupStyles } from "../../theme/style";
import { Box } from "@mui/material";
import TickMark from "../../../assets/images/signup_images/TickMark.svg";

// # Component
const Card = ({
  otherSelectedValue,
  name,
  handleChange,
  keyField,
  isOtherSelected,
  icon,
  screen,
  displayStyle,
  selectedFunctions,
}) => {
  const theme = useTheme();
  const classes = accountSetupStyles(theme);
  let className =
    name === otherSelectedValue || isOtherSelected
      ? classes.setupJobroleCardSelected
      : classes.setupJobroleCard;

  if (screen === "functions") {
    className =
      selectedFunctions?.includes(name) || isOtherSelected
        ? classes.setupJobroleCardSelected
        : classes.setupJobroleCard;
  }

  // # JSX
  return (
    <div
      className={className}
      onClick={() => handleChange(keyField, name)}
      id={name}
      // style={{ flexWrap: isOtherSelected ? "wrap" : "none" }}
    >
      {screen === "functions" ? (
        <div style={{ display: "flex", alignItems: "center" }}>
          <i
            className="material-icons-outlined"
            style={{ marginRight: theme.size[25], fontSize: theme.size[18] }}
          >
            widgets
          </i>
          <div className={classes.setupCardHeading} id={name}>
            {name.length > 18 ? `${name.slice(0, 18)}...` : name}
            {isOtherSelected && (
              <div
                className={classes.setupCardSubheading}
                title={otherSelectedValue.length > 5 ? otherSelectedValue : ""}
                style={{
                  flexBasis: "100%",
                  textAlign: "center",
                  fontWeight: "500",
                }}
              >{`(${
                otherSelectedValue.length > 5
                  ? `${otherSelectedValue.slice(0, 5)}...`
                  : otherSelectedValue
              })`}</div>
            )}
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            className={classes.setupCardIcon}
            id={name}
            src={icon}
            alt=""
            style={{ height: theme.size[20] }}
          />
          <div className={classes.setupCardHeading} id={name}>
            {name}
            {isOtherSelected && (
              <div
                className={classes.setupCardSubheading}
                title={otherSelectedValue.length > 5 ? otherSelectedValue : ""}
                style={{
                  flexBasis: "100%",
                  textAlign: "center",
                  fontWeight: "500",
                }}
              >{`(${
                otherSelectedValue.length > 5
                  ? `${otherSelectedValue.slice(0, 5)}...`
                  : otherSelectedValue
              })`}</div>
            )}
          </div>
        </div>
      )}
      <Box sx={{ width: theme.size[20] }}>
        <Box
          component="img"
          alt="Logo"
          sx={{
            display: displayStyle,
            height: theme.size[10],
          }}
          src={TickMark}
        />
      </Box>
    </div>
  );
};

// # Exports
export default Card;
